import { getPropsFromNode, nodeListToArray, nodeMatches } from '../utils'
import { h } from '../parser/utils'

export const NAME = 'pre'

export function matches(node) {
  return nodeMatches(node, 'pre')
}

export async function transform (node, next, ctx) {
  const nodes = nodeListToArray(node.childNodes)
    .filter(node => node.nodeName.toLowerCase() !== 'br')

  const children = await next(nodes, ctx)

  const props = getPropsFromNode(node)

  return h('pre', props, ...children)
}
